let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lPQcc"), load("c6fAG")]).then(() => parcelRequire('jOztW'));